import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ModalLayout from '@appbase/templates/ModalLayout/ModalLayout.vue'
import ResourceInformation from './ResourceInformation.vue'

@Component({
    components: {
        ModalLayout,
        ResourceInformation
    }
})
export default class ResourceInformationModal  extends Vue {
    @Prop({ type: String }) value!: string
}